import { render, staticRenderFns } from "./threadBaseModal.vue?vue&type=template&id=3a475a68&"
import script from "./threadBaseModal.vue?vue&type=script&lang=js&"
export * from "./threadBaseModal.vue?vue&type=script&lang=js&"
import style0 from "./threadBaseModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports